import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const PieChart = ({ data, allTitles, colors, onSliceClick }) => {
  const formattedData = data.map((value, idx) => ({
    name: allTitles?.[idx] ?? `Item ${idx + 1}`,
    y: value,
  }));

  const options = {
    chart: {
      type: "pie",
      height: 400,
      spacing: [20, 0, 20, 0],
    },
    title: {
      text: "",
      align: "center",
    },
    tooltip: {
      pointFormat: "<b>{point.y}</b> ({point.percentage:.1f}%)",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        colors: colors,
        center: ["50%", "50%"],
        size: "80%",
        dataLabels: [
          {
            enabled: true,
            distance: 20,
            format: "{point.name}"
          },
          {
            enabled: true,
            distance: -40,
            format: "{point.percentage:.1f}%",
            style: {
              fontSize: "1.2em",
              textOutline: "none",
              opacity: 0.7,
            },
            filter: {
              operator: ">",
              property: "percentage",
              value: 10,
            },
          },
        ],
        point: {
          events: {
            click: function () {
              if (onSliceClick) {
                onSliceClick(this);
              }
            },
          },
        },
      },
    },
    series: [
      {
        name: "Area",
        colorByPoint: true,
        data: formattedData,
      },
    ],
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PieChart;
